import { render, staticRenderFns } from "./MultipleQuotaFull.vue?vue&type=template&id=6ac0eb52&"
import script from "./MultipleQuotaFull.vue?vue&type=script&lang=js&"
export * from "./MultipleQuotaFull.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports